<template>
  <div id="app">
    <router-view v-if="!loading" />
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      loading: true
    }
  },
  async created() {
    let clientInfo = await this.$client.init()
    this.loading = false
    this.$logger.init(clientInfo)
    this.$axios.defaults.baseURL = process.env.VUE_APP_API_SERVER
    this.$axios.defaults.headers.token = clientInfo.token
  }
}
</script>

<style>
#app {
  font-family: system, -apple-system, BlinkMacSystemFont, Roboto, Helvetica, Sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
</style>
